export type PractitionerData<ParamedicalProfession> = {
   paramedicalProfessions: ParamedicalProfession[];
};

export type MedicalRoleVisitor<Data extends PractitionerData<unknown>, T> = {
   visitDoctor: (practitionerData: Data) => T;
   visitParamedic: (paramedicalProfessions: NonEmptyArray<Data['paramedicalProfessions'][number]>) => T;
   visitUnknown: () => T;
};

type NonEmptyArray<Item> = [Item, ...Item[]];

const isParamedic = <ParamedicalProfession>(
   paramedicalProfessions: ParamedicalProfession[]
): paramedicalProfessions is NonEmptyArray<ParamedicalProfession> => {
   return paramedicalProfessions.length > 0;
};

export const createMedicalRoleVisitor = <Data extends PractitionerData<unknown>>(
   practitionerData: Data | null | undefined
) => <T>(visitor: MedicalRoleVisitor<Data, T>): T => {
   if (!practitionerData) {
      return visitor.visitUnknown();
   }

   if (isParamedic(practitionerData.paramedicalProfessions)) {
      return visitor.visitParamedic(practitionerData.paramedicalProfessions);
   }

   return visitor.visitDoctor(practitionerData);
};
